module.exports = __webpack_public_path__ + "img/logo_entreprise.e5058d7a.png";